export const systemLanguages = ['he', 'ar', 'en'];

/**
 * Label columns configuration for the Labels Management page.
 * Each column defines its display id, the language to send to API, and optional workspace.
 */
export const labelColumns = [
    { id: 'he', lang: 'he', workspace: 'ofek' },
    { id: 'ar', lang: 'ar', workspace: 'ofek' },
    // { id: 'en', lang: 'en', workspace: 'ofek' },
    { id: 'ivritil', lang: 'en', workspace: 'ivritil' },
];
export const workspaces = ['ofek', 'ivritil', 'myTestBox'];

/**
 * Language + Workspace combinations for dropdown selectors.
 * Each option defines what language and workspace to send to the API.
 */
export const languageWorkspaceOptions = [
    { id: 'he_ofek', lang: 'he', workspace: 'ofek', labelKey: 'he_ofek' },
    { id: 'ar_ofek', lang: 'ar', workspace: 'ofek', labelKey: 'ar_ofek' },
    { id: 'en_ofek', lang: 'en', workspace: 'ofek', labelKey: 'en_ofek' },
    { id: 'en_ivritil', lang: 'en', workspace: 'ivritil', labelKey: 'en_ivritil' },
    { id: 'he_myTestBox', lang: 'he', workspace: 'myTestBox', labelKey: 'he_myTestBox' }
];

export const services = {
  nairobiApi: 'nairobiapi'
};

export const pages = [
  {
    key: 'home',
    icon: 'k-i-home',
    content: [
      { title: "unidentified_page" },
      { key: "hero_marketing_banner", type: "heroMarketingBanner", settingsData: { minSize: 1, maxSize: 3 } },
      { key: "hero_video", type: "heroVideo" },
      { key: "text_image_banner", type: "textImageBanner", settingsData: { minSize: 3, maxSize: 3, type: ['general'] } },
      { key: "general_banner", type: "generalBanner", settingsData: { minSize: 1, maxSize: 1, type: ['general'] } },
      { key: "what_interests_you", type: "swimlineListContent", settingsData: { line_location: false, title: "${labels.pagesManagement.menu.home.what_interests_you} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.swimlineListContent.swimline_list_title_home_page_identified_and_unidentified}" } },
      { key: "content_line", type: "swimlineContent", settingsData: { line_location: true, title: "${labels.pagesManagement.swimlineContent.swimline} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.swimlineContent.swimline_title_home_page_identified_and_unidentified}" } },

      { title: "identified_page" },
      { key: "quick_links", type: "quickLinks", settingsData: { minSize: 1, maxSize: 6 } },
      { key: "text_media_banner_personal", type: "textMediaBanner", settingsData: { maxSize: 30, type: 'personal', tabs: true, title: "${labels.pagesManagement.menu.home.text_media_banner_personal} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.menu.home.text_media_banner_personal_title} " } },
      { key: "general_banner_personal", type: "generalBanner", settingsData: { minSize: 1, maxSize: 1, type: ['personal'] } },
    ]
  },
  {
    key: 'books',
    icon: 'k-i-dictionary-add',
    content: [
      { title: "unidentified_page" },
      { key: "text_image_banner", type: "textMediaBanner", settingsData: { maxSize: 1, minSize: 1, buttonDisabled: true, type: "general", title: "${labels.pagesManagement.textMediaBanner.text_media} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.textMediaBanner.text_media_title_books_page_unidentified}" } },
      { key: "video_banner", type: "videoBanner", settingsData: { maxSize: 1, minSize: 1, type: "general", title: "${labels.pagesManagement.videoBanner.video} - (${settings.listLength}/${settings.maxSize})" } },
      { key: "hero_marketing_banner", type: "marketingBanner", settingsData: { maxSize: 3, type: "general", title: "${labels.pagesManagement.marketingBanner.marketing_banner} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.marketingBanner.marketing_banner_title_books_page_unidentified}" } },
      //{key: "content_line", type: "swimlineContent", settingsData: {line_location: false, title: "${labels.pagesManagement.swimlineContent.swimline} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.swimlineContent.swimline_title_books_page_identified_and_unidentified}"}},
      { key: "content_line", type: "swimlineListContent", settingsData: { line_location: false, title: "${labels.pagesManagement.swimlineListContent.swimline_list} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.swimlineListContent.swimline_list_title_books_page_identified_and_unidentified}" } },
    ]
  },
  {
    key: 'courses',
    icon: 'k-i-ungroup',
    content: [
      { title: "unidentified_page" },
      { key: "text_image_banner", type: "textMediaBanner", settingsData: { maxSize: 1, minSize: 1, buttonDisabled: true, type: "general", title: "${labels.pagesManagement.textMediaBanner.text_media} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.textMediaBanner.text_media_title_courses_page_unidentified}" } },
      { key: "video_banner", type: "videoBanner", settingsData: { maxSize: 1, minSize: 1, type: "general", title: "${labels.pagesManagement.videoBanner.video} - (${settings.listLength}/${settings.maxSize})" } },
      { key: "hero_marketing_banner", type: "marketingBanner", settingsData: { maxSize: 3, type: "general", title: "${labels.pagesManagement.marketingBanner.marketing_banner} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.marketingBanner.marketing_banner_title_courses_page_unidentified}" } },
      //{key: "content_line", type: "swimlineContent", settingsData: {line_location: false, title: "${labels.pagesManagement.swimlineContent.swimline} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.swimlineContent.swimline_title_courses_page_identified_and_unidentified}"}},
      { key: "content_line", type: "swimlineListContent", settingsData: { line_location: false, title: "${labels.pagesManagement.swimlineListContent.swimline_list} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.swimlineListContent.swimline_list_title_courses_page_identified_and_unidentified}" } },
    ]
  },
  {
    key: 'tools',
    icon: 'k-i-module-manager',
    content: [
      { title: "tools_page" },
      // { key: "text_image_banner", type: "textMediaBanner", settingsData: { maxSize: 1, minSize: 1, buttonDisabled: true, maxTextSize: 125, type: "general", title: "${labels.pagesManagement.textMediaBanner.text_media} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.textMediaBanner.text_media_title_tools_page}" } },
      { key: "marketing_banner", type: "marketingBanner", settingsData: { maxSize: 1, minSize: 1, bannerTypes: ["video", "triple"], type: "general", title: "${labels.pagesManagement.marketingBanner.marketing_banner_video_triple} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.marketingBanner.marketing_banner_title_tools_page}" } },
      { key: "recommended_sites", type: "linksList", settingsData: { maxSize: 30, minSize: 1, title: "${labels.pagesManagement.menu.tools.recommended_sites}" } },
    ]
  },
  {
    key: 'teachersLearn',
    icon: 'k-i-myspace',
    content: [
      { title: "unidentified_page" },
      { key: "text_image_banner", type: "textMediaBanner", settingsData: { title: "${labels.pagesManagement.textMediaBanner.text_media}" } },
      { key: "video_banner", type: "videoBanner", settingsData: { maxSize: 1, minSize: 1, type: "general", title: "${labels.pagesManagement.videoBanner.video} - (${settings.listLength}/${settings.maxSize})" } },
      { key: "content_line", type: "swimlineContent", settingsData: { maxSize: 4, minSize: 1, line_location: false, title: "${labels.pagesManagement.swimlineContent.swimline} - (${settings.listLength}/${settings.maxSize}) ${labels.pagesManagement.swimlineContent.swimline_title_home_page_identified_and_unidentified}" } },
    ]
  },
  {
    key: 'search',
    icon: 'k-i-search',
    seoOnly: true,
    content: [
      { title: "unidentified_page" },
      { key: "seo", type: "empty" },
    ]
  },
  {
    key: 'recommendations',
    icon: 'k-i-star',
    seoOnly: true,
    content: [
      { title: "unidentified_page" },
      { key: "seo", type: "empty" },
    ]
  },
  {
    key: 'catalog',
    icon: 'k-i-folder-open',
    seoOnly: true,
    content: [
      { title: "unidentified_page" },
      { key: "seo", type: "empty" },
    ]
  },
  {
    key: 'my-favorites',
    icon: 'k-i-favorite',
    seoOnly: true,
    content: [
      { title: "unidentified_page" },
      { key: "seo", type: "empty" },
    ]
  },
  {
    key: 'my-profile',
    icon: 'k-i-user',
    seoOnly: true,
    content: [
      { title: "unidentified_page" },
      { key: "seo", type: "empty" },
    ]
  },
  //{
  //  key: 'recommendations',
  //  icon: 'k-i-track-changes-enable',
  //  defaultContent: []
  //},
  //{
  //  key: 'sequences',
  //  icon: 'k-i-track-changes-enable',
  //  defaultContent: []
  //},
  //{
  //  key: 'my-studio',
  //  icon: 'k-i-track-changes-enable',
  //  defaultContent: []
  //},
  //{
  //  key: 'my-content',
  //  icon: 'k-i-track-changes-enable',
  //  defaultContent: []
  //},
  //{
  //  key: 'catalog',
  //  icon: 'k-i-track-changes-enable',
  //  defaultContent: []
  //},
  //{
  //  key: 'learning-management',
  //  icon: 'k-i-track-changes-enable',
  //  defaultContent: []
  //},
  //{
  //  key: 'online-meetings',
  //  icon: 'k-i-track-changes-enable',
  //  defaultContent: []
  //},
  //{
  //  key: 'micro-courses',
  //  icon: 'k-i-track-changes-enable',
  //  defaultContent: []
  //},
];